import React, { useState } from "react";

const SidebarDropdown = ({ title, icon, submenu,path, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasSubmenu = submenu.length > 0;

  const toggleDropdown = () => {
    if (!hasSubmenu) {
      // Handle click action for items without submenu
      // Add your logic here
      return;
    }
    setIsOpen(!isOpen);
  };

  return (
    <li className="nav-item">
      <a
        className={`nav-link d-flex align-items-center justify-content-start ${isOpen ? "active" : ""}`}
        data-bs-toggle={hasSubmenu ? "collapse" : ""}
        role="button"
        aria-controls="pagesExamples"
        onClick={toggleDropdown}
        aria-expanded={isOpen}
        
      >
        
        {hasSubmenu && (
          <><div className="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i className={icon}></i>
          </div><span className="nav-link-text ms-1">{title}</span><i
           
            style={{ marginLeft: "auto" }}
            onClick={toggleDropdown}
          ></i></>
        )}
        {!hasSubmenu && (
          <>
          <a href={path} style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
          <div className="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i className={icon}></i>
          </div><span className="nav-link-text ms-1">{title}</span>
          </a>
        
          </>
        )}

      </a>
      {hasSubmenu && (
        <div
          className={`collapse ${isOpen ? "show" : ""}`}
          id="pagesExamples"
          style={{}}
        >
          <ul className="nav nav-sm flex-column">{children}</ul>
        </div>
      )}
    </li>
  );
};

export default SidebarDropdown;
